import { omit } from 'lodash';
import { catchError, of } from 'rxjs';
import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControlOptions, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ValidationHelper } from '@diktup/frontend/helpers';

import { MobileAuthService } from '../../services';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { NavController } from '@ionic/angular';
import { ToasterService } from '../../shared/services';

@Component({
  template: '',
})
export class MobileResetPasswordComponent implements OnInit {
  current = '/';
  token: string;
  resultUrl: string;
  isButtonDisabled: boolean;
  resetPasswordForm: FormGroup;

  constructor(
    protected router: Router,
    protected navCtrl: NavController,
    protected formBuilder: FormBuilder,
    protected translate: TranslateService,
    protected authService: MobileAuthService,
    protected toasterService: ToasterService,
    protected activatedRoute: ActivatedRoute,
    protected changeDetectorRef: ChangeDetectorRef,
    @Inject(DOCUMENT) protected document: Document,
    @Inject(PLATFORM_ID) protected platformId: Object,
  ) {
    this.activatedRoute.params.subscribe((params) => {
      if (params['token']) {
        this.token = params['token']?.split('&')[0];
        this.resultUrl = this.router.url;
        if (this.resultUrl === '/v/') {
          this.authService
            .validateEmailForTarget(this.token)
            .pipe(
              catchError(() => {
                this.toasterService.error(this.translate.instant('SHARED.SOMETHING_WENT_WRONG'));
                this.changeDetectorRef.markForCheck();
                return of(null);
              }),
            )
            .subscribe((res) => {
              if (res) {
                this.toasterService.success(this.translate.instant('SHARED.EMAIL_VERIFIED'));
                this.navCtrl.navigateRoot('/');
                this.changeDetectorRef.markForCheck();
              }
            });
        }
      }
    });
  }

  ngOnInit(): void {
    this.resetPasswordForm = this.formBuilder.group({
      pwd: this.formBuilder.group(
        {
          password: ['', Validators.required],
          confirmPassword: ['', Validators.required],
        },
        { validators: [ValidationHelper.matchingFields('password', 'confirmPassword')] } as AbstractControlOptions,
      ),
    });
  }

  resetPassword(): void {
    this.isButtonDisabled = true;
    const formValue = {
      ...omit(this.resetPasswordForm.value, 'pwd'),
      password: this.resetPasswordForm.value.pwd.password,
    };
    this.authService
      .resetPasswordForTarget(localStorage.getItem('posId'), formValue.password, this.token)
      .pipe(
        catchError(() => {
          this.toasterService.error(this.translate.instant('STH_WENT_WRONG'));
          this.changeDetectorRef.markForCheck();
          return of(null);
        }),
      )
      .subscribe((res) => {
        if (res) {
          this.toasterService.success(this.translate.instant('PASSWORD_RESET_SUCCESS'));
          this.navCtrl.navigateRoot('/auth/login');
          this.changeDetectorRef.markForCheck();
        }
      });
  }
}
